export default __webpack_public_path__ + "static/media/node.aa201976.png";